module.exports = __webpack_public_path__ + "static/media/msr-loading@2x.0ca46879.gif";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/msr-loading@2x.gif
// module id = 510
// module chunks = 0